module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('table', {
    staticClass: "chapter-title-corner-decorations",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-left",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_left.png"
    }
  })])]), _c('td', {
    staticClass: "chapter-title-corner-decoration-middle-column"
  }), _c('td', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-right",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_right.png"
    }
  })])])])])]), _c('div', {
    staticClass: "chapter-title"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-above",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_above.png"
    }
  })])]), _c('h1', {
    staticClass: "chapter-title"
  }, [_vm._v("Ringraziamenti")]), _vm._v(" "), _c('div', {
    staticClass: "chapter-title-decoration-below"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-below-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-below",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_below.png"
    }
  })])])]), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "blockquote",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Vorrei ringraziare diverse persone per avermi aiutato a far emergere Windflower dalla mia testa e a trasferirlo nelle pagine di questo libro. Tra loro, i miei primi lettori come Lynne e Joan che mi hanno dato molti suggerimenti preziosi guidandomi in questo viaggio. Anche i lettori successivi, come Andy e la mia guida editoriale Ruth Latta, mi hanno aiutato a ritrovare il focus e a sembrare più brillante. Insieme all'amore costante e al sostegno della mia compagna, Joan, che ha davvero reso possibile tutto questo.")])]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "blockquote",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Infine, al meraviglioso popolo e al paesaggio di Terranova, fonti di ispirazione per questa creazione. Sono grato al tempo, sì, anche alla nebbia che può offuscare il sole ma ci mantiene anche al sicuro e ci fornisce indubbiamente materiale di cui parlare e scrivere.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26d5053e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c002.vue
// module id = 63
// module chunks = 0